import { forwardRef, type Ref, type SVGProps } from "react";
const IconSyncFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M17.005 2.683a2 2 0 0 0-3.01 2.634l.598.683H4a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h3a2 2 0 1 0 0-4H6V10h8.593l-.598.683a2 2 0 1 0 3.01 2.634l3.5-4a2 2 0 0 0 0-2.634zM23 8a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H17.407l.598.683a2 2 0 1 1-3.01 2.634l-3.5-4a2 2 0 0 1 0-2.634l3.5-4a2 2 0 0 1 3.01 2.634l-.598.683H26V10h-1a2 2 0 0 1-2-2" />
  </svg>
);
const ForwardRef = forwardRef(IconSyncFilledSVG);
ForwardRef.displayName = "IconSyncFilled";
export { ForwardRef as IconSyncFilled };
